const deleteFile = (event: Event) => {
    const eventTarget = event.target as HTMLElement;
    const fileItem = eventTarget.closest<HTMLElement>('.js-upload-file');

    fileItem?.remove();
};

const shortenFileName = (fileName: string, maxLength = 18) => {
    // Проверка, что длина имени файла больше максимальной
    if (fileName.length <= maxLength) return fileName;

    // Вычисляем, сколько символов необходимо с каждой стороны
    const frontChars = Math.ceil(maxLength / 2 - 4); // 4 - длинна формата файла
    const backChars = Math.ceil(maxLength / 2);

    // Обрезаем имя файла и добавляем точки посередине
    return fileName.substring(0, frontChars) + '...' + fileName.substring(fileName.length - backChars);
};

const addHiddenInput = (fileName: string, fileResult: string) => {
    const hiddenInput = document.createElement('input');
    hiddenInput.type = 'hidden';
    hiddenInput.classList.add('js-file-hidden-input');
    hiddenInput.name = `upload_file_${fileName}`;
    hiddenInput.value = fileResult;
    return hiddenInput;
};

const createFileUploadItem = (file: File, value: string) => {
    const item = document.createElement('div');
    item.classList.add('upload-file__item', 'js-upload-file');
    item.innerHTML = `
        <button type="button" class="upload-file__delete js-delete-file" data-value="${shortenFileName(value)}">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 6L6 18M6 6L18 18" stroke="white" stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="bevel">
                </path>
            </svg>
        </button>
        <div class="upload-file__name">${shortenFileName(file.name)}</div>
    `;

    // добавляем скрытый инпут
    // const hiddenInput = addHiddenInput(file.name, value);
    // item.appendChild(hiddenInput);

    // Добавляем обработчик события на кнопку
    const deleteButton = item.querySelector('.js-delete-file');
    deleteButton?.addEventListener('click', deleteFile);

    return item;
};

const onChange = (event: Event) => {
    const eventTarget = event.target as HTMLElement;
    const input = eventTarget.closest<HTMLInputElement>('.js-file-input');
    const wrapper = eventTarget.closest<HTMLElement>('.js-file-input-wrapper');

    if (input && wrapper) {
        const previewEl = wrapper.querySelector<HTMLElement>('.js-file-input-preview');
        const files = input.files;

        if (files && files.length > 0 && previewEl) {
            new Promise((resolve) => {
                if (input.classList.contains('js-all-files')) {
                    const error = wrapper.querySelector('.js-file-input-error');
                    if (error) error.innerHTML = '';

                    Array.from(files).forEach((file) => {
                        const fileReader = new FileReader();
                        fileReader.readAsDataURL(file);
                        fileReader.onload = () => {
                            if (fileReader.result && typeof fileReader.result === 'string') {
                                // размер файла не больше 100мб
                                if (file.size / (1024 * 1024) < 100) {
                                    const fileItem = createFileUploadItem(file, fileReader.result);
                                    previewEl.appendChild(fileItem);
                                    input.value = '';
                                } else {
                                    if (error) {
                                        error.innerHTML =
                                            'The file size is too large. Please upload a file not larger than 100mb';
                                    }
                                }
                            }
                        };
                    });
                } else {
                    // картинка до 256x256
                    const fileReader = new FileReader();
                    fileReader.readAsDataURL(files[0]);
                    fileReader.onload = () => {
                        if (fileReader.result && typeof fileReader.result === 'string') {
                            previewEl.innerHTML = '';
                            const img = document.createElement('img');
                            img.alt = '';
                            img.src = fileReader.result;
                            img.onload = () => {
                                if (img.width <= 256 && img.height <= 256) {
                                    previewEl.appendChild(img);
                                } else {
                                    const error = document.createElement('div');
                                    error.innerHTML =
                                        'Image resolution is too high, please, load image up to 256x256 px';
                                    previewEl.appendChild(error);
                                }
                            };
                        }
                    };
                    resolve(0);
                }
            });
        }
    }
};

function init(container: HTMLElement | Document = document) {
    const fileInputWrappers = Array.from(container.querySelectorAll<HTMLElement>('.js-file-input-wrapper'));

    fileInputWrappers.forEach((wrapper) => {
        const previewEl = wrapper.querySelector<HTMLElement>('.js-file-input-preview');
        const input = wrapper.querySelector<HTMLInputElement>('.js-file-input');

        if (input && previewEl) {
            input.addEventListener('change', onChange);
        }
    });
}

function destroy(container: HTMLElement | Document = document) {
    const fileInputWrappers = Array.from(container.querySelectorAll<HTMLElement>('.js-file-input-wrapper'));

    fileInputWrappers.forEach((wrapper) => {
        const previewEl = wrapper.querySelector<HTMLElement>('.js-file-input-preview');
        const input = wrapper.querySelector<HTMLInputElement>('.js-file-input');

        if (input && previewEl) {
            input.addEventListener('change', onChange);
        }
    });
}

const _module = { init, destroy };

export default _module;
